import styled from 'styled-components';
import {Caption1} from '../../../../../components/typography';

export const ValueTitle = styled(Caption1)`
  max-width: 40mm;
  word-wrap: break-word;
`;

export default {ValueTitle};
